import React from 'react';
import { Box, LinearProgress, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTheme } from '../context/ThemeContext';

export default function QuizLayout({ current, total, label, onBack, children }) {
    const pct = total > 0 ? (current / total) * 100 : 0;
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    const bg = isDark
        ? 'linear-gradient(135deg, #0d0d1a 0%, #12122a 40%, #0a1628 100%)'
        : 'linear-gradient(135deg, #dddaf0 0%, #e0ddf2 40%, #d8e0f0 100%)';
    const topbarBg = isDark ? 'rgba(13,13,26,0.85)' : 'rgba(220,218,240,0.92)';
    const topbarBorder = isDark ? 'rgba(255,255,255,0.05)' : 'rgba(80,70,140,0.12)';
    const labelColor = isDark ? '#7878a0' : '#5050a0';
    const counterColor = isDark ? '#e8e8f0' : '#1a1830';
    const progressBg = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(80,70,140,0.1)';
    const glow1 = isDark ? 'rgba(108,99,255,0.12)' : 'rgba(108,99,255,0.07)';
    const glow2 = isDark ? 'rgba(37,117,252,0.08)' : 'rgba(37,117,252,0.05)';

    return (
        <Box sx={{
            minHeight: '100vh', width: '100%', background: bg,
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            pt: { xs: 8, sm: 10 }, pb: 6, px: { xs: 2, sm: 3 },
            position: 'relative', overflow: 'hidden',
            '&::before': { content: '""', position: 'fixed', top: '-20%', right: '-10%', width: '60vw', height: '60vw', borderRadius: '50%', background: `radial-gradient(circle, ${glow1} 0%, transparent 70%)`, pointerEvents: 'none', zIndex: 0 },
            '&::after': { content: '""', position: 'fixed', bottom: '-20%', left: '-10%', width: '50vw', height: '50vw', borderRadius: '50%', background: `radial-gradient(circle, ${glow2} 0%, transparent 70%)`, pointerEvents: 'none', zIndex: 0 },
        }}>
            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100 }}>
                <LinearProgress variant="determinate" value={pct} sx={{
                    height: 3, background: progressBg,
                    '& .MuiLinearProgress-bar': { background: 'linear-gradient(90deg, #6c63ff, #2575fc)', transition: 'transform 0.4s ease' },
                }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: { xs: 1, sm: 2 }, py: 0.5, background: topbarBg, backdropFilter: 'blur(12px)', borderBottom: `1px solid ${topbarBorder}` }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {onBack && (
                            <IconButton onClick={onBack} size="small" sx={{ color: labelColor, '&:hover': { color: '#6c63ff', background: 'rgba(108,99,255,0.1)' } }}>
                                <ArrowBackIcon fontSize="small" />
                            </IconButton>
                        )}
                        <Typography sx={{ color: labelColor, fontSize: '0.78rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em', fontFamily: "'DM Sans', sans-serif" }}>
                            {label}
                        </Typography>
                    </Box>
                    <Typography sx={{ color: counterColor, fontSize: '0.85rem', fontWeight: 700, fontFamily: "'Syne', sans-serif", pr: { xs: 1, sm: 2 } }}>
                        {current} <span style={{ color: labelColor, fontWeight: 400 }}>/ {total}</span>
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ width: '100%', maxWidth: 560, position: 'relative', zIndex: 1 }}>
                {children}
            </Box>
        </Box>
    );
}
